import { createContext, useContext, useState, ReactNode } from "react";

interface CursorState {
  label: string;
  active: boolean;
}

interface CursorContextType {
  cursor: CursorState;
  setCursorLabel: (label: string) => void;
  clearCursor: () => void;
}

const CursorContext = createContext<CursorContextType>({
  cursor: { label: "", active: false },
  setCursorLabel: () => {},
  clearCursor: () => {},
});

export const CursorProvider = ({ children }: { children: ReactNode }) => {
  const [cursor, setCursor] = useState<CursorState>({ label: "", active: false });

  const setCursorLabel = (label: string) => setCursor({ label, active: true });
  const clearCursor = () => setCursor({ label: "", active: false });

  return (
    <CursorContext.Provider value={{ cursor, setCursorLabel, clearCursor }}>
      {children}
    </CursorContext.Provider>
  );
};

export const useCursor = () => useContext(CursorContext);
